import React, { useEffect, useState } from 'react';
import { Form, Space } from 'antd';
import TicketsSearchForm from '../../../forms/TicketsSearchForm';
import TicketsTable from '../../../tables/ticketsTable/TicketsTable';
import { getAdminTickets } from '../../../../../services/admin/ticketServices';

function LocalTickets() {
  const [form] = Form.useForm();
  const [data, setData] = useState(null);

  const fetchData = async (page) => {
    const res = await getAdminTickets(page, form.getFieldsValue());

    if (res?.status === 'success') {
      setData(res?.data);
    }
  };

  useEffect(() => {
    fetchData(1);
  }, []);

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <TicketsSearchForm onFinish={() => fetchData(data?.meta?.currentPage)} form={form} />
      <TicketsTable data={data} fetchData={fetchData} />
    </Space>
  );
}

export default LocalTickets;
